import { downgradeComponent } from "@angular/upgrade/static";
import { StreamaxConfigsAccountListComponent } from "@app/main/modules/foundation/_routes/streamax-configs/account-list/streamax-configs-account-list.component";
import { StreamaxConfigsComponent } from "@app/main/modules/foundation/_routes/streamax-configs/streamax-configs-account-view.component";
import { AuthorizationService } from "@app/services/authorization.service";
import { CustomerUserList } from "@foundation/_routes/customers/userList/user-list.component";
import { HomeComponent } from "@foundation/_routes/home/home.component";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { UserPlatform } from "../../../interfaces/IUser";
import "./_components/components.module.ajs";
import "./_routes/commissions/commission.module.ajs";
import { CustomerSubscriptionsPageComponent } from "./_routes/customers/customer-subscriptions-page/customer-subscriptions-page.component";
import { CustomerSubscriptionsComponent } from "./_routes/customers/customer-subscriptions/customer-subscriptions.component";
import { FoundationCustomerEditComponent } from "./_routes/customers/customerEdit/customer-edit.component";
import { CustomerOverviewComponent } from "./_routes/customers/customerOverview/customer-overview.component";
import { CustomerViewComponent } from "./_routes/customers/customerView/customer-view.component";
import { FoundationCustomersComponent } from "./_routes/customers/customers.component";
import { JsonDebugViewComponent } from "./_routes/developerConsole/debug-json-view/debug-json-view.component";
import { DeveloperConsoleComponent } from "./_routes/developerConsole/developer-console.component";
import { DeviceHealthAccountsComponent } from "./_routes/device-health/components/device-health-accounts/device-health-accounts.component";
import { DeviceHealthVehicleViewComponent } from "./_routes/device-health/components/device-health-vehicle-view/device-health-vehicle-view.component";
import { DeviceHealthVehiclesComponent } from "./_routes/device-health/components/device-health-vehicles/device-health-vehicles.component";
import { DeviceHealthComponent } from "./_routes/device-health/components/device-health/device-health.component";
import { EngineerCommissionHistoryListComponent } from "./_routes/engineer-commission-history/engineer-commission-history-list.component";
import { EngineerJobItemListComponent } from "./_routes/engineer-job-items/engineer-job-item-list.component";
import { EngineerUsersComponent } from "./_routes/engineer-users/engineer-users-list.component";
import { CameraViewComponent } from "./_routes/hardware/peripherals/camera-view/camera-view.component";
import { PeripheralListComponent } from "./_routes/hardware/peripherals/peripheral-list/peripheral-list.component";
import { PeripheralViewComponent } from "./_routes/hardware/peripherals/peripheral-view/peripheral-view.component";
import { SimListComponent } from "./_routes/hardware/sim/sim-list/sim-list.component";
import { UnitListComponent } from "./_routes/hardware/units/unit-list/unit-list.component";
import { UnitLogsComponent } from "./_routes/hardware/units/unit-logs/unit-logs.component";
import { UnitViewComponent } from "./_routes/hardware/units/unit-view/unit-view.component";
import { JobDetailsComponent } from "./_routes/jobs/job-details/job-details.component";
import { JobListComponent } from "./_routes/jobs/job-list.component";
import { ReleaseNotesComponent } from "./_routes/release-notes/release-notes.component";
import { ApplicationManagerComponent } from "./_routes/rv-lite/application/_components/application-manager/application-manager.component";
import { CameraConfigurationComponent } from "./_routes/rv-lite/camera-config/camera-configuration.component";
import { ConfigManagerComponent } from "./_routes/rv-lite/config/_components/config-manager/config-manager.component";
import { RVLiteComponent } from "./_routes/rv-lite/rv-lite.component";
import { FoundationVehicleListComponent } from "./_routes/vehicles/vehicle-list.component";
import { VehicleViewComponent } from "./_routes/vehicles/vehicleView/vehicle-view.component";
import { VisitFailuresComponent } from "./_routes/visit-failures/visit-failures.component";
import { FoundationAccountService } from "./_services/account.service.ajs";
import { NotesService } from "./_services/notes.service.ajs";
import { FoundationPeripheralService } from "./_services/peripheral.service.ajs";
import { FoundationUserService } from "./_services/user.service.ajs";
import { FoundationVehicleService } from "./_services/vehicle.service.ajs";
import { FoundationNavigationModule } from "./foundation.navigation";


export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        var routeConfigHelper = routeConfigHelperProvider.$get();

        $stateProvider.state(FoundationNavigationModule.HomePage, {
            url: "/home",
            views: { "content@app": { component: "foundationHomePage" } },
            data: { translation: 'Common.Home' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.ConfigManager, {
            url: "/config-manager",
            views: { "content@app": { component: "configManager" } },
            data: { translation: 'ConfigManagement.ConfigManagement', subtitleTranslationKey: "ConfigManagement.ConfigSubTitle" }
        });


        $stateProvider.state(FoundationNavigationModule.AppManager, {
            url: "/app-manager",
            views: { "content@app": { component: "appManager" } },
            data: { translation: 'AppManagement.AppManagement', subtitleTranslationKey: "AppManagement.AppSubTitle" }
        });

        $stateProvider.state(FoundationNavigationModule.CameraConfig, {
            url: "/camera-configuration",
            views: { "content@app": { component: "cameraConfiguration" } },
            data: { translation: 'CameraConfiguration.CameraConfiguration', subtitleTranslationKey: "CameraConfiguration.CameraConfigurationSubTitle" }
        });

        $stateProvider.state(FoundationNavigationModule.Commissioning, {
            url: "/commissioning",
            views: { "content@app": { component: "commissionList" } },
            data: { translation: 'Common.Commissioning', subtitleTranslationKey: "Commissions.CommissioningSubTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            stateName: `${FoundationNavigationModule.Commissioning}.view`,
            translation: 'Common.Commissioning',
            bindingName: "commissionId",
            component: "commissionDetail",
            breadcrumbNameResolverKey: "commissionDescription"
        });

        $stateProvider.state(FoundationNavigationModule.NewCommissionWithBindings, {
            url: "/new/:jobItemId/:customerId",
            views: {
                "content@app": { component: "commissionEditor", bindings: { jobItemId: "jobItemId", customerId: "customerId"} }
            },
            data: { translation: 'Commissions.NewCommission', subtitleTranslationKey: "Commissions.CreateNewSubtitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.NewCommissionNoBindings, {
            url: "/new",
            views: {
                "content@app": {
                    component: "commissionEditor"
                }
            },
            data: { translation: 'Commissions.NewCommission', subtitleTranslationKey: "Commissions.CreateNewSubtitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.NPS, {
            url: "/nps",
            views: { "content@app": { component: "npsDashboard" } },
            data: { translation: "NpsRater.RouteTitle", subtitleTranslationKey: "NpsRater.RouteSubtitle" }
        });

        routeConfigHelper.createDetailStateWithBoundParams({ url: "/new", bindingName: "jobItemId", stateName: FoundationNavigationModule.JobItemsCommissionNew, component: "commissionEditor", translation: 'Common.NewCommission' });

        $stateProvider.state(FoundationNavigationModule.Customers, {
            url: "/customers",
            views: { "content@app": { component: "foundationCustomers" } },
            data: { translation: 'Common.Customers', subtitleTranslationKey: "FoundationCustomers.CustomersSubTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.CustomerSubscriptions, {
            url: "/subscriptions",
            views: { "content@app": { component: "customerSubscriptionsPage" } },
            data: { translation: 'CustomerSubscriptionsPage.Subscriptions', subtitleTranslationKey: "CustomerSubscriptionsPage.SubscriptionsSubTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "customerId",
            stateName: FoundationNavigationModule.CustomerView,
            component: "foundationCustomerView",
            breadcrumbNameResolverKey: "companyNameBreadcrumbKey"
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/new",
            bindingName: "customerId",
            stateName: FoundationNavigationModule.CustomerNew,
            component: "foundationCustomerEdit"
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/edit",
            bindingName: "customerId",
            stateName: FoundationNavigationModule.CustomerEdit,
            component: "foundationCustomerEdit",
            breadcrumbNameResolverKey: "companyNameBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.ReleaseNotes, {
            url: "/release-notes",
            views: { "content@app": { component: "releaseNotes" } },
            data: { translation: "ReleaseNotes.ReleaseNotes", subtitleTranslationKey: "ReleaseNotes.ReleaseNotesSubTitle" }
        });

        $stateProvider.state(FoundationNavigationModule.Vehicles, {
            url: "/vehicles",
            views: { "content@app": { component: "foundationVehicleList" } },
            data: { translation: 'Common.Vehicles', subtitle: "View or edit vehicle information" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.DeviceHealth, {
            url: "/device-health",
            views: { "content@app": { component: "deviceHealth" } },
            data: { translation: 'DeviceHealth.Title', subtitleTranslationKey: 'DeviceHealth.VehiclesSubTitle' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "vehicleId",
            queryParamsNames: ["filterBy"],
            stateName: FoundationNavigationModule.DeviceHealthVehicleView,
            component: "deviceHealthVehicleView",
            translation: "DeviceHealth.Vehicles",
            breadcrumbNameResolverKey: "shortRegBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.DeviceHealthCompanies, {
            url: "/vehicles",
            views: { "content@app": { component: "foundationVehicleList" } },
            data: { translation: 'Common.Vehicles', subtitle: "View or edit vehicle information" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "vehicleId",
            stateName: FoundationNavigationModule.VehicleView,
            component: "vehicleView",
            translation: "Common.Vehicle",
            breadcrumbNameResolverKey: "shortRegBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.Units, {
            url: "/units",
            views: { "content@app": { component: "unitList" } },
            data: { translation: 'FoundationUnits.Units', subtitleTranslationKey: "FoundationUnits.UnitsListSubTitle" }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "unitSerial",
            stateName: `${FoundationNavigationModule.Units}.view`,
            component: "unitView",
            translation: "FoundationUnits.Units",
            breadcrumbNameResolverKey: "unitNameBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.Cameras, {
            url: "/cameras",
            views: { "content@app": { component: "peripheralList" } },
            data: { translation: 'Common.Cameras', subtitleTranslationKey: "FoundationPeripherals.CameraListSubTitle" }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "serial",
            stateName: `${FoundationNavigationModule.Cameras}.view`,
            component: "cameraView",
            translation: "Common.Cameras",
            breadcrumbNameResolverKey: "peripheralNameBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.Peripherals, {
            url: "/peripherals",
            views: { "content@app": { component: "peripheralList" } },
            data: { translation: 'Common.Peripherals', subtitleTranslationKey: "FoundationPeripherals.PeripheralListSubTitle" }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/view",
            bindingName: "serial",
            stateName: `${FoundationNavigationModule.Peripherals}.view`,
            component: "peripheralView",
            translation: "Common.Peripherals",
            breadcrumbNameResolverKey: "peripheralNameBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.Sims, {
            url: "/sims",
            views: { "content@app": { component: "simList" } },
            data: { translation: 'FoundationSims.Sims', subtitleTranslationKey: "FoundationSims.SimListDescription" }
        });

        $stateProvider.state(FoundationNavigationModule.RVLite, {
            url: "/roadview",
            views: { "content@app": { component: "rvLite" } },
            data: { translation: 'RVLite.RVLite', subtitleTranslationKey: "RVLite.RVLiteDescription" }
        });

        $stateProvider.state(FoundationNavigationModule.StreamaxConfigsAccountList, {
            url: "/streamax-configs-account-list",
            views: { "content@app": { component: "streamaxConfigsAccountList" } },
            data: { translation: 'StreamaxConfigs.StreamaxConfigs', subtitleTranslationKey: "StreamaxConfigs.StreamaxConfigsSubtitle" }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: "/accountview",
            stateName: `${FoundationNavigationModule.StreamaxConfigsAccountView}`,
            translation: "Common.Jobs",
            bindingName: "accountId",
            component: "streamaxConfigsAccountView",
            breadcrumbNameResolverKey: "configAccountBreadcrumbKey"
        })

        $stateProvider.state(FoundationNavigationModule.Jobs, {
            url: "/jobs",
            views: { "content@app": { component: "jobList" } },
            data: { translation: 'Common.Jobs', subtitleTranslationKey: "EngineerJobs.JobsSubTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        routeConfigHelper.createDetailStateWithBoundParams({
            url: '/view',
            stateName: FoundationNavigationModule.JobView,
            translation: "Common.Jobs",
            bindingName: "jobId",
            component: "jobDetails",
            breadcrumbNameResolverKey: "jobBreadcrumbKey"
        });

        $stateProvider.state(FoundationNavigationModule.VisitFailures, {
            url: "/visit-failures",
            views: { "content@app": { component: "visitFailures" } },
            data: { translation: 'VisitFailures.VisitFailures', subtitleTranslationKey: "VisitFailures.VisitFailuresSubtitle" }
        });

        $stateProvider.state(FoundationNavigationModule.JobItems, {
            url: "/engineerjobitems",
            views: { "content@app": { component: "engineerJobItemList" } },
            data: { translation: 'EngineerJobItemList.JobItems', subtitleTranslationKey: "EngineerJobItemList.JobItemsSubTitle" }
        });

        $stateProvider.state(FoundationNavigationModule.EngineerHistory, {
            url: "/engineer-history",
            views: { "content@app": { component: "engineerCommissionHistoryList" } },
            data: { translation: 'EngineerHistory.CommissionHistory', subtitleTranslationKey: "EngineerHistory.CommissionHistorySubtitle" }
        });

        $stateProvider.state(FoundationNavigationModule.DeveloperConsole, {
            url: "/console",
            views: { "content@app": { component: "developerConsole" } },
            data: { translation: 'DeveloperConsole.Console', subtitleTranslationKey: "DeveloperConsole.ConsoleSubtitle" }
        });

        $stateProvider.state(FoundationNavigationModule.Engineers, {
            url: "/engineers",
            views: { "content@app": { component: "engineerUsers" } },
            data: { translation: 'EngineerUsers.Engineers', subtitleTranslationKey: "EngineerUsers.EngineersSubTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForEngineer()]
            }
        });

        $stateProvider.state(FoundationNavigationModule.ParentRoot, {
            abstract: true,
            url: "/foundation",
            redirectTo: FoundationNavigationModule.Default,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Foundation', theme: "AddSecure", userPlatform: UserPlatform.Foundation }
        });
    }
}

angular
    .module("app.foundation", [
        "app.directives",
        "app.foundation.commission",
        "app.foundation.components",/*, "app.foundation.tickets"*/])
    .config(Config)

    .service("foundationAccountService", FoundationAccountService)


    .service("foundationUserService", FoundationUserService)
    .service("foundationVehicleService", FoundationVehicleService)
    .service("foundationPeripheralService", FoundationPeripheralService)
    .service("notesService", NotesService)

    .component("foundationHomePage", new HomeComponent())

    .directive("foundationCustomers", downgradeComponent({ component: FoundationCustomersComponent }))
    .directive("engineerUsers", downgradeComponent({ component: EngineerUsersComponent }))
    .directive("jobList", downgradeComponent({ component: JobListComponent }))
    .directive("engineerJobItemList", downgradeComponent({ component: EngineerJobItemListComponent }))
    .directive("engineerCommissionHistoryList", downgradeComponent({ component: EngineerCommissionHistoryListComponent }))
    .directive("developerConsole", downgradeComponent({ component: DeveloperConsoleComponent }))
    .directive("jsonDebugView", downgradeComponent({ component: JsonDebugViewComponent }))
    .directive("jobDetails", downgradeComponent({ component: JobDetailsComponent }))
    .directive("foundationVehicleList", downgradeComponent({ component: FoundationVehicleListComponent }))
    .directive("vehicleView", downgradeComponent({ component: VehicleViewComponent }))
    .directive("customerOverview", downgradeComponent({ component: CustomerOverviewComponent }))
    .directive("customerUserList", downgradeComponent({ component: CustomerUserList }))
    .directive("foundationCustomerView", downgradeComponent({ component: CustomerViewComponent }))
    .directive("foundationCustomerEdit", downgradeComponent({ component: FoundationCustomerEditComponent }))

    .directive("deviceHealth", downgradeComponent({ component: DeviceHealthComponent }))
    .directive("deviceHealthAccounts", downgradeComponent({ component: DeviceHealthAccountsComponent }))
    .directive("deviceHealthVehicles", downgradeComponent({ component: DeviceHealthVehiclesComponent }))
    .directive("deviceHealthVehicleView", downgradeComponent({ component: DeviceHealthVehicleViewComponent }))

    .directive("customerSubscriptions", downgradeComponent({ component: CustomerSubscriptionsComponent }))
    .directive("customerSubscriptionsPage", downgradeComponent({ component: CustomerSubscriptionsPageComponent }))

    .directive("configManager", downgradeComponent({ component: ConfigManagerComponent }))
    .directive("appManager", downgradeComponent({ component: ApplicationManagerComponent }))
    .directive("cameraConfiguration", downgradeComponent({ component: CameraConfigurationComponent }))

    .directive("peripheralList", downgradeComponent({ component: PeripheralListComponent }))
    .directive("simList", downgradeComponent({ component: SimListComponent }))
    .directive("rvLite", downgradeComponent({ component: RVLiteComponent }))
    .directive("streamaxConfigsAccountList", downgradeComponent({ component: StreamaxConfigsAccountListComponent }))
    .directive("streamaxConfigsAccountView", downgradeComponent({ component: StreamaxConfigsComponent }))
    .directive("unitList", downgradeComponent({ component: UnitListComponent }))
    .directive("unitView", downgradeComponent({ component: UnitViewComponent }))

    .directive("unitLogs", downgradeComponent({ component: UnitLogsComponent }))
    .directive("peripheralView", downgradeComponent({ component: PeripheralViewComponent }))
    .directive("cameraView", downgradeComponent({ component: CameraViewComponent }))
    .directive("visitFailures", downgradeComponent({ component: VisitFailuresComponent }))


    .directive("releaseNotes", downgradeComponent({ component: ReleaseNotesComponent }))

    ;
